/**
 * Company types
 *
 * @type {{}}
 */
export const types = {
  company: 'company',
  nursery: 'nursery',
  veterinary: 'veterinary',
  supplier: 'supplier',
  warehouse: 'warehouse',
  store: 'offline_store',
  pickup_department: 'pickup_department',
  filial: 'filial'
};
export const companiesTypes = {
  [types.company]: 'Компания',
  [types.nursery]: 'Питомник',
  [types.veterinary]: 'Ветклиника',
  [types.supplier]: 'Поставщик',
  [types.warehouse]: 'Склад',
  [types.store]: 'Магазин',
  [types.pickup_department]: 'Пункт самовывоза',
  [types.filial]: 'Филиал'
};
/**
 * Company selling types
 *
 * @type {{}}
 */

export const sellingTypes = {
  both: 'both',
  online: 'online',
  offline: 'offline'
};
export const companiesSellingTypes = {
  [sellingTypes.both]: 'Онлайн и оффлайн',
  [sellingTypes.online]: 'Онлайн',
  [sellingTypes.offline]: 'Оффлайн'
};
/**
 * Offer updated type
 *
 * @type {{auto: string, manual: string}}
 */

export const updatedType = {
  auto: 'auto',
  manual: 'manual'
};
export const updatedTypeTitle = {
  [updatedType.auto]: 'Авто',
  [updatedType.manual]: 'Ручной'
};
/**
 * Inventory tags zones types
 *
 * @type {object}
 */

export const inventoryTypes = {
  exist: 'exist',
  missing: 'missing'
};